import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import withLoader from 'components/Shared/withLoader';

import { fetchReclamationDemandesEnlevement } from 'store/reclamation/detailsActions';

import DemandesEnlevement from './DemandesEnlevement';

const DemandesEnlevementWithLoader = withLoader(DemandesEnlevement);

class DemandesEnlevementContainer extends React.Component {
    
    componentDidMount() {
        this.props.fetchReclamationDemandesEnlevement(this.props.reclamationId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reclamationId !== this.props.reclamationId) {
            this.props.fetchReclamationDemandesEnlevement(this.props.reclamationId);
        }
    }

    render() {

        let { reclamations } = this.props;

        return (
            <DemandesEnlevementWithLoader
                isLoading={this.props.isLoading}
                reclamations={reclamations}
            />
        );
    }
}

DemandesEnlevementContainer.propTypes = {
    reclamationId: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
    isLoading: state.reclamation.details.demandesEnlevement.isLoading,
    reclamations: state.reclamation.details.demandesEnlevement.items
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationDemandesEnlevement: (reclamationId) => dispatch(fetchReclamationDemandesEnlevement(reclamationId))
});

export default connect(mapStateToProps, mapDispatchToProps)(DemandesEnlevementContainer);